import {
     doesStringHaveSpecialChars, isPasswordStrong
} from "../../util/Validators";

// let newPass= '';

export const validateInput = (name, value) => {
    let hasError = false,
        error = "";
    switch (name) {
        case "originalPassword":
            if (value.trim() === "") {
                hasError = true;
                error = "Original Password cannot be empty";
            }             
            break
        case "newPassword":
            if (value.trim() === "") {
                hasError = true;
                error = "New Password cannot be empty";
            } else if (isPasswordStrong(value)===false) {
                hasError = true;
                error = "You must use a strong password with atleast 8 characters, one uppercase letter, one lowercase letter, one number and one special character";
            }         
            else {
                hasError = false;
                error = "";
                // newPass=value.trim();
            }
            
            break
        case "verifyNewPassword":
            if (value.trim() === "") {
                hasError = true;
                error = "Verify Password cannot be empty";
            } /* else if (newPass!==value.trim()) {
                hasError = true;
                error = "New Password does not match with verify password"
            } */ else {
                hasError = false;
                error = "";
            }
            break   
        default:
            break
    }
    return { hasError, error }
}